<template>
  <div
    class="flex flex-col h-full gap-2 bg-light-grey rounded-xl p-4 overflow-hidden shadow-lg border border-gray-100"
  >
    <div class="flex justify-between">
      <p class="text-primary-900 text-lg">
        {{ $t("home.caller_last_tickets.title") }}
      </p>
      <Button
        rounded
        class="bg-white text-sm p-2 rounded-full !text-primary-500 shadow-md hover:!bg-primary-900 hover:!text-white"
        @click="Create"
        :disabled="loading"
        ><v-icon>mdi-plus</v-icon></Button
      >
    </div>
    <div v-if="loading" class="flex flex-col flex-1 items-center gap-4">
      <Skeleton class="!h-1/6 w-full rounded-xl" />
      <Skeleton class="!h-1/6 w-full rounded-xl" />
      <Skeleton class="!h-1/6 w-full rounded-xl" />
      <Skeleton class="!h-1/6 w-full rounded-xl" />
      <Skeleton class="!h-1/6 w-full rounded-xl" />
    </div>
    <simple-bar
      class="flex flex-col overflow-y-scroll mb-8"
      v-else-if="lastTickets?.length > 0"
    >
      <div
        v-for="(ticket, i) in lastTickets ? lastTickets : []"
        :key="i"
        class="flex justify-between items-center bg-white p-4 rounded-xl me-8 my-2 shadow-md border border-gray-100"
      >
        <div class="flex items-center gap-3">
          <div>
            <p class="text-primary-900 text-sm">
              {{ `${$t("home.ticket_number")} ${ticket["المعرف"]}` }}
            </p>
            <div class="flex items-center gap-1 mt-2 text-xs">
              <v-icon class="text-primary-500">mdi-clock-outline</v-icon>
              <p class="text-primary-500">
                {{ getTime(ticket["تاريخ الانشاء"]) }}
              </p>
              <div class="gap-5" />
              <v-icon class="text-primary-500"
                >mdi-calendar-blank-outline</v-icon
              >
              <p class="text-primary-500">
                {{ getDate(ticket["تاريخ الانشاء"]) }}
              </p>
              <div class="gap-5" />
              <Badge class="bg-primary-500 text-xs" />
              <p class="text-primary-500">
                {{ ticket["حالة الطلب"] }}
              </p>
            </div>
          </div>
        </div>
        <Button
          rounded
          class="bg-nature-grey hover:bg-primary-900 hover:!text-white text-sm p-2 rounded-full !text-primary-500"
          @click="viewTicket(ticket)"
          ><v-icon>mdi-eye-outline</v-icon></Button
        >
      </div>
    </simple-bar>
    <div
      v-else
      class="flex flex-col flex-1 items-center justify-center overflow-y-auto"
    >
      {{ $t("home.caller_last_tickets.no_last_tickets") }}
    </div>
    <create-new-ticket
      :open="openTicketCreate"
      @close="openTicketCreate = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CreateNewTicket from "./CreateNewTicket.vue";
import { getTime, getDate } from "@/utils";
import { Badge, Button, Skeleton } from "primevue";

export default {
  components: {
    CreateNewTicket,
    Badge,
    Button,
    Skeleton,
  },
  props: {
    senderId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      lastTickets: [],
      lastTicketsInterval: null,
      openTicketCreate: false,
      loading: false,
      ticketsHeader: [
        // "رقم الطلب",
        // "عنوان التذكرة",
        // "نوع الطلب",
        // "الفرع",
        // "حالة الطلب",
        // "تاريخ الانشاء",
        // "تاريخ اخر تحديث",
      ],
    };
  },
  methods: {
    ...mapActions(["GetCallerLastTickets", "SetMessageDialog"]),
    fieldClass(key) {
      if (key == this.ticketsHeader[0]) {
        return "bg-teal";
      } else {
        return "bg-grey-lighten-4 text-grey-darken-1";
      }
    },
    async getLastTickets() {
      this.loading = true;
      try {
        const callerId = this.inCall
          ? this.currentCall?.SourceID
          : this.senderId;
        var resp = await this.GetCallerLastTickets(callerId);
        if (resp.success) {
          this.lastTickets = resp.lastTickets;
          if (this.lastTickets.length > 0) {
            this.ticketsHeader = [];
            for (const head of Object.keys(this.lastTickets[0])) {
              this.ticketsHeader.push(head);
            }
          }
        }
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.SetMessageDialog({ show: true, message: message });
      } finally {
        this.loading = false;
      }
    },
    Create() {
      // console.log("My crm init", this.CRMInitInfo);
      // if (this.CRMInitInfo?.has_ticket_create) {
      //   this.openTicketCreate = true;
      // } else {
      //   const url = this.CRMInitInfo.open_ticket_api.replace(
      //     "{CallerID}",
      //     this.currentCall?.SourceID || this.senderId
      //   );
      //   window.open(url, "_blank").focus();
      // }
    },
    viewTicket() {
      // const url = this.CRMInitInfo.ticket_api.replace(
      //   "{ticketID}",
      //   Object.values(ticket)[0]
      // );
      // window.open(url, "_blank").focus();
    },
    async initTickets() {
      // if (!this.caller.includes("1234567")) {
      //   this.lastTickets = [];
      // }
      await this.getLastTickets();
      // this.lastTicketsInterval = setInterval(() => {
      //   this.getLastTickets();
      // }, 15000);
      // this.$store.commit("setLastTicketsInterval", this.lastTicketsInterval);
    },
    getTime(date) {
      return getTime(date);
    },
    getDate(date) {
      return getDate(date);
    },
  },
  computed: {
    ...mapGetters([
      "CRMInitInfo",
      "currentCall",
      "ticketingLocalFields",
      "inCall",
    ]),
    localizedCallerNumber() {
      // return this.$t("home.caller_last_tickets.title", {
      //   caller: this.$n(
      //     parseInt(this.currentCall?.SourceID, 10),
      //     "mainNum",
      //     "ar-EG"
      //   ),
      // });
      return this.$t("home.caller_last_tickets.title", {
        caller: this.currentCall?.SourceID,
      });
    },
    disableCreateBtn() {
      return (
        this.CRMInitInfo?.has_ticket_create &&
        (!this.ticketingLocalFields || this.ticketingLocalFields?.length == 0)
      );
    },
  },
  watch: {
    async currentCall(newValue) {
      if (newValue) {
        await this.initTickets();
      }
    },
    senderId(val) {
      if (val && !this.inCall) {
        this.initTickets();
      }
    },
    openTicketCreate(value) {
      this.$emit("inTicketMode", value);
    },
  },
  async mounted() {
    if (
      (this.currentCall && this.currentCall?.SourceID != "") ||
      this.senderId
    ) {
      await this.initTickets();
    }
  },
  beforeUnmount() {
    if (this.lastTicketsInterval) {
      clearInterval(this.lastTicketsInterval);
      this.lastTicketsInterval = null;
    }
  },
};
</script>
<style></style>
